import { StaticComponentGrid, StaticComponentTitle } from "../../LeadDetails.styles.ts";
import React from "react";
import LabeledField from "features/LeadGen/pages/LeadDetails/components/LabeledField/LabeledField.tsx";
import * as S from "./LeadDetailsInformation.styles.ts";

interface LeadDetailsInformationProps {
	header: string;
	info: {
		label: string;
		value: string | null | undefined;
		testId?: string;
	}[];
}

const LeadDetailsInformation = ({ header, info }: LeadDetailsInformationProps) => {
	return (
		<S.Container>
			<StaticComponentTitle>{header}</StaticComponentTitle>
			<StaticComponentGrid>
				{info.map(({ label, testId, value }) => (
					<LabeledField
						key={testId}
						label={label}
						value={value?.trim()}
						dataTestId={testId}
					/>
				))}
			</StaticComponentGrid>
		</S.Container>
	);
};

export default LeadDetailsInformation;
